import { useEffect, useState } from 'react';
/** Display only. Cached allowances never participate in quote or payment authorization. */
export function useFundingLimitDisplay(options, checkout) {
  const key = JSON.stringify(['onramp-limit-display-v2', options.client.progressKey ?? options.client.cacheKey, options.currency, options.decimals, checkout.customerVerification?.customerId ?? 'guest', checkout.method, checkout.location?.country, checkout.location?.subdivision, options.fundingFx?.source, options.fundingFx?.convention, options.fundingFx?.observedAt]);
  const [snapshot, setSnapshot] = useState(null);
  const review = checkout.state === 'amount' ? checkout.preview.review : checkout.review;
  useEffect(() => {
    const raw = options.limitStorage?.get(key);
    if (!raw) return;
    try {
      const value = JSON.parse(raw);
      if (!value || typeof value !== 'object' || !('savedAt' in value) || typeof value.savedAt !== 'number' || !Number.isFinite(value.savedAt) || value.savedAt > Date.now() || Date.now() - value.savedAt > 30 * 60 * 1000 || !('limits' in value) || !Array.isArray(value.limits)) return;
      const limits = [];
      for (const entry of value.limits) {
        const item = entry;
        if (!item || typeof item !== 'object' || !('period' in item) || item.period !== 'daily' && item.period !== 'monthly' && item.period !== 'yearly' || !('limitUnits' in item) || !('remainingUnits' in item) || typeof item.limitUnits !== 'string' || !/^\d{1,20}$/.test(item.limitUnits) || typeof item.remainingUnits !== 'string' || !/^\d{1,20}$/.test(item.remainingUnits)) return;
        const original = {};
        if ('originalCurrency' in item) {
          if (typeof item.originalCurrency !== 'string' || !/^[A-Z]{3}$/.test(item.originalCurrency) || !('originalDecimals' in item) || typeof item.originalDecimals !== 'number' || !Number.isInteger(item.originalDecimals) || item.originalDecimals < 0 || item.originalDecimals > 4 || !('originalLimitUnits' in item) || typeof item.originalLimitUnits !== 'string' || !/^\d{1,20}$/.test(item.originalLimitUnits) || !('originalRemainingUnits' in item) || typeof item.originalRemainingUnits !== 'string' || !/^\d{1,20}$/.test(item.originalRemainingUnits) || !('converted' in item) || typeof item.converted !== 'boolean') return;
          original.originalCurrency = item.originalCurrency;
          original.originalDecimals = item.originalDecimals;
          original.originalLimitUnits = item.originalLimitUnits;
          original.originalRemainingUnits = item.originalRemainingUnits;
          original.converted = item.converted;
        }
        limits.push({
          ...original,
          period: item.period,
          limitUnits: item.limitUnits,
          remainingUnits: item.remainingUnits
        });
      }
      setSnapshot({
        key,
        limits
      });
    } catch {
      // Invalid cached display data is discarded; live provider data remains authoritative.
    }
  }, [key, options.limitStorage]);
  useEffect(() => {
    if (!review) return;
    setSnapshot({
      key,
      limits: review.limits
    });
    options.limitStorage?.set(key, JSON.stringify({
      savedAt: Date.now(),
      limits: review.limits
    }));
  }, [key, review, options.limitStorage]);
  return review?.limits ?? (snapshot?.key === key ? snapshot.limits : []);
}